/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rail_InsideInputs */

const en_rail_inside = /** @type {(inputs: Rail_InsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inside`)
};

/**
* | output |
* | --- |
* | "Inside" |
*
* @param {Rail_InsideInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const rail_inside = /** @type {((inputs?: Rail_InsideInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rail_InsideInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_rail_inside(inputs)
});